"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RevolvingDot = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var RevolvingDot = function RevolvingDot(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      version: "1.1",
      width: props.width,
      height: props.height,
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      fill: "none",
      stroke: props.color,
      strokeWidth: "4",
      cx: "50",
      cy: "50",
      r: props.radius + 38,
      style: {
        opacity: 0.5
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      fill: props.color,
      stroke: props.color,
      strokeWidth: "3",
      cx: "8",
      cy: "54",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      attributeName: "transform",
      dur: "2s",
      type: "rotate",
      from: "0 50 48",
      to: "360 50 52",
      repeatCount: "indefinite"
    })))
  );
};

exports.RevolvingDot = RevolvingDot;
RevolvingDot.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
RevolvingDot.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 6
};